import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import SelectInput from '@/common/components/SelectInput';
import useSearchBox from '../hooks/useSearchBox';
import { REPORT_QUIZ_DOMAINS } from '../../quizReport/constants/domains';
import { TEST_OPTIONS } from '../constants/tests';
import { COMPARE_OPTIONS } from '../constants/compareOptions';

const QuizTestReportSearchBox = ({ handleSearchCallback }) => {
	const hook = useSearchBox({ handleSearchCallback });

	return (
		<form onSubmit={(e) => hook.handleSearch(e)}>
			<SearchBarCenter>
				<div>
					<Input
						name='Browsing Person Created From'
						width={180}
						color={Colors.darkBlue}
						inputRef={hook.dateFromRef}
						type='date'
						value={hook.today}
						inputWidth={140}
						hasIncDec
						required
					/>
					<Input
						name='Browsing Person Created To'
						width={180}
						color={Colors.darkBlue}
						inputRef={hook.dateToRef}
						type='date'
						value={hook.today}
						inputWidth={140}
						hasIncDec
						required
					/>
					<SelectInput
						name='Domain'
						color={Colors.darkBlue}
						width={180}
						selectWidth={240}
						selected={hook.selectedDomain}
						setSelected={hook.setSelectedDomain}
						options={REPORT_QUIZ_DOMAINS.map((domain) => {
							return { label: domain, value: domain };
						})}
						required
					/>
				</div>
				<div>
					<SelectInput
						name='Compare Source'
						color={Colors.darkBlue}
						width={180}
						selectWidth={200}
						selected={hook.selectedCompareSource}
						setSelected={hook.setSelectedCompareSource}
						options={COMPARE_OPTIONS}
						required
					/>
					<SelectInput
						name='Compare To'
						color={Colors.darkBlue}
						width={180}
						selectWidth={200}
						selected={hook.selectedCompareTo}
						setSelected={hook.setSelectedCompareTo}
						options={COMPARE_OPTIONS}
						required
					/>
					<SelectInput
						name='Test'
						color={Colors.darkBlue}
						width={180}
						selectWidth={200}
						selected={hook.selectedTest}
						setSelected={hook.setSelectedTest}
						options={TEST_OPTIONS}
						required
					/>
				</div>
				<ActionButton type='submit' text='Search' />
			</SearchBarCenter>
		</form>
	);
};

export default QuizTestReportSearchBox;
